/**
 * Coerce API values to renderable plain text. Prevents React #31 when a field
 * is accidentally an object (e.g. nested metadata) or non-string.
 */
export function asPlainText(value, fallback = '') {
  if (value == null) return fallback;
  if (typeof value === 'string') return value;
  if (typeof value === 'number' || typeof value === 'boolean') return String(value);
  return fallback;
}

/** Keep in sync with backend `is_valid_bonita_content` (server.py). */
const BONITA_FAILURE_SUBSTRINGS = [
  'bonita encountered an issue',
  'temporarily unavailable',
  'please try again',
  'taking a break',
  'try again later',
];

export function isBonitaFailurePlainText(value) {
  const s = asPlainText(value).toLowerCase().trim();
  if (!s) return true;
  return BONITA_FAILURE_SUBSTRINGS.some((m) => s.includes(m));
}

/** Drop junk Bonita/spark rows from feed arrays; leave normal posts untouched. */
export function shouldShowBonitaFeedPost(post) {
  if (!post) return false;
  const bonitaLike = post.user_id === 'bonita' || post.is_spark;
  if (!bonitaLike) return true;
  return !isBonitaFailurePlainText(post.content);
}

export const BONITA_FEED_PLACEHOLDER =
  'Bonita is reconnecting — fresh takes will land here soon.';
